import { inject, Injectable } from '@angular/core';
import { loadScript } from '../lib/load-script';
import { DataLoaderService } from './data-loader.service';

export const GOOGLE_API_KEY = 'AIzaSyA3QtG-HpoiklX8jid6_AriI9ToWlEbzfg';
const CLIENT_ID = '387343500342-obn0crc436d0kubai59g2frmat1sbmvl.apps.googleusercontent.com';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gapi: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    google: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleApiService {
  private loader = inject(DataLoaderService);

  private async loadGoogleClient(scope: string, clientName: string) {
    return this.loader.get('google-drive-client' + scope, async () => {
      await loadScript('https://apis.google.com/js/api.js');
      await loadScript('https://accounts.google.com/gsi/client');
      await this.loadGapi(clientName);

      return window.google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope,
      });
    });
  }

  public async requestAccess(scope: string, clientName: string): Promise<string> {
    const tokenClient = await this.loadGoogleClient(scope, clientName);
    return new Promise(resolve => {
      // Request an access token.
      let accessToken: string | null = null;
      tokenClient.callback = response => {
        if (response.error !== undefined) {
          throw response;
        }
        accessToken = response.access_token;
        resolve(accessToken);
      };

      if (accessToken === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({ prompt: '' });
      }
    });
  }

  private async loadGapi(clientName: string) {
    return new Promise<void>(resolve => {
      window.gapi.load(clientName, resolve);
    });
  }
}
